import React from 'react';
import { ArrowRight, Check, Crown } from 'lucide-react';
export function UpgradeSection() {
  return <section className="py-16 md:py-24 bg-[#18181B] px-5 relative overflow-hidden" data-id="element-321">
      {/* Subtle gold ambient glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-amber-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-322"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-323">
        {/* Header */}
        <div className="text-center mb-10" data-id="element-324">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-500/20 to-yellow-500/20 border border-amber-400/40 text-amber-300 font-bold px-6 py-2.5 rounded-full mb-6 uppercase tracking-wider text-xs shadow-[0_0_20px_rgba(245,158,11,0.15)]" data-id="element-325">
            <Crown className="w-4 h-4" data-id="element-326" />
            Edición Premium Exclusiva
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-white tracking-tight mb-4" data-id="element-327">
            👑 Llevá tu transformación al siguiente nivel
          </h2>
          <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-328">
            Sumá 3 libros exclusivos diseñados para la{' '}
            <span className="text-amber-300 font-semibold" data-id="element-329">
              Pre y Postmenopausia
            </span>{' '}
            y potenciá los resultados del Manual
          </p>
        </div>

        {/* Product image */}
        <div className="flex justify-center mb-10" data-id="element-330">
          <a href="https://checkot2.descargatop.com/cart/50167813898597:1" target="_blank" rel="noopener noreferrer" data-id="element-331">
            <img src="https://cdn.magicpatterns.com/uploads/thHvbeJYF3cWaRATv7PqiB/mocap_compra_mejorada.png" alt="Paquete completo: Manual + 800 Recetas + 3 Libros Exclusivos para la Pre y Postmenopausia" className="max-w-full h-auto max-h-72 md:max-h-96 object-contain drop-shadow-2xl" data-id="element-332" />
          </a>
        </div>

        {/* Card with details */}
        <div className="bg-white rounded-3xl p-6 md:p-10 max-w-3xl mx-auto relative overflow-hidden border border-amber-200 shadow-[0_0_40px_rgba(245,158,11,0.1)]" data-id="element-333">
          {/* Gold top accent */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-amber-400 via-yellow-300 to-amber-400" data-id="element-334"></div>

          <div className="flex items-center justify-center gap-2 mb-6" data-id="element-335">
            <Crown className="w-5 h-5 text-amber-500" data-id="element-336" />
            <p className="text-center text-sm font-bold text-amber-600 uppercase tracking-wider" data-id="element-337">
              Todo lo del plan básico + 3 libros exclusivos
            </p>
            <Crown className="w-5 h-5 text-amber-500" data-id="element-338" />
          </div>

          <div className="space-y-4 mb-8" data-id="element-339">
            {[{
            emoji: '📘',
            title: 'Comidas para las Emociones',
            desc: 'Recetas que nutren tu bienestar emocional durante la pre y postmenopausia'
          }, {
            emoji: '📗',
            title: 'El Secreto de la Buena Digestión',
            desc: 'Mejorá tu digestión y reducí la hinchazón con alimentos específicos para tu etapa'
          }, {
            emoji: '📙',
            title: 'Equilibrá tu Glucosa',
            desc: 'Controlá los picos de azúcar y estabilizá tu energía durante la menopausia'
          }].map((book, i) => <div key={i} className="flex items-start gap-4 p-4 rounded-xl border border-amber-100 bg-amber-50/50" data-id="element-340">
                <span className="text-3xl shrink-0" data-id="element-341">{book.emoji}</span>
                <div data-id="element-342">
                  <h4 className="font-bold text-gray-900 text-base mb-1" data-id="element-343">
                    {book.title}
                  </h4>
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-344">
                    {book.desc}
                  </p>
                </div>
              </div>)}
          </div>

          {/* What's included summary */}
          <div className="border-t border-gray-100 pt-6 mb-6" data-id="element-345">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-346">
              {['Manual de Biohacking + 800 Recetas', '6 bonos gratis incluidos', '3 libros exclusivos', 'Acceso inmediato y de por vida'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-347">
                  <Check className="w-4 h-4 text-emerald-600 shrink-0" strokeWidth={3} data-id="element-348" />
                  <span className="text-sm text-gray-700 font-medium" data-id="element-349">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Price */}
          <div className="text-center mb-6 bg-gradient-to-b from-amber-50/50 to-transparent rounded-2xl p-6" data-id="element-350">
            <p className="text-gray-400 text-base line-through mb-1" data-id="element-351">USD $79</p>
            <span className="text-4xl md:text-6xl font-black text-gray-900 tracking-tighter" data-id="element-352">
              USD $17,99
            </span>
            <p className="text-gray-500 text-sm mt-1" data-id="element-353">
              (Pagás en tu moneda local)
            </p>
          </div>

          {/* CTA */}
          <a href="https://checkot2.descargatop.com/cart/50167813898597:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white text-center text-lg md:text-xl font-bold py-5 rounded-2xl shadow-lg hover:shadow-amber-500/30 transition-all transform hover:-translate-y-0.5 group relative overflow-hidden" data-id="element-354">
            <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-355">
              👑 QUIERO EL PAQUETE PREMIUM
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-356" />
            </span>
            <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-357"></div>
          </a>

          <p className="text-center text-xs text-gray-400 mt-4" data-id="element-358">
            Incluye todo lo del plan básico + los 3 libros exclusivos
          </p>
        </div>
      </div>
    </section>;
}